import React from 'react';
import styles from './MapPin.module.scss';

const DEFAULT_PIN_WIDTH = 50;
const DEFAULT_PIN_HEIGHT = 64;
const DEFAULT_BOTTOM_DOT_WIDTH = 8;
const DEFAULT_BOTTOM_DOT_HEIGHT = 8;
const DEFAULT_BOTTOM_DOT_X = 20.998;
const DEFAULT_BOTTOM_DOT_Y = 55;

export interface MapPinProps {
  pinBackgroundColor: string;
  bottomDotStrokeColor: string;
  bottomDotBackgroundColor: string;
  children?: React.ReactElement;
  pinWidth?: number;
  pinHeight?: number;
  bottomDotWidth?: number;
  bottomDotHeight?: number;
  bottomDotX?: number;
  bottomDotY?: number;
}

export const MapPin = ({
  pinBackgroundColor,
  bottomDotBackgroundColor,
  bottomDotStrokeColor,
  children,
  pinHeight = DEFAULT_PIN_HEIGHT,
  pinWidth = DEFAULT_PIN_WIDTH,
}: MapPinProps) => {
  return (
    <div className={styles.MapPinContainer} style={{ width: `${pinWidth}px` }}>
      <div className={styles.MapPinIcon} style={{ marginTop: '10px' }}>
        {children}
      </div>
      <div className="MapPinImage">
        <svg
          width={pinWidth}
          height={pinHeight}
          viewBox={`0 0 ${pinWidth} ${pinHeight}`}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_ddd_9545_30615)">
            <path
              d="M45 24.1758C45 27.9247 43.6364 32.3429 40.4545 36.9143C37.8826 40.6095 29.3706 48.1878 26.2022 50.9571C25.4995 51.5712 24.4713 51.6049 23.7395 51.0258C20.9529 48.8207 14.1517 43.1518 9.54545 36.9143C6.3764 32.6229 5 28.0624 5 24.1758C5 13.033 13.9543 4 25 4C36.0457 4 45 13.033 45 24.1758Z"
              style={{ fill: pinBackgroundColor }}
              transform={`translate(0,10)`}
            />
          </g>
          {/* <rect
            x={bottomDotX}
            y={bottomDotY}
            width={bottomDotWidth}
            height={bottomDotHeight}
            rx="4"
            fill={bottomDotBackgroundColor}
            stroke={bottomDotStrokeColor}
            strokeWidth="2"
          /> */}
          <defs>
            <filter
              id="filter0_ddd_9545_30615"
              x="0"
              y="0"
              width={pinWidth}
              height={pinHeight}
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="1" />
              <feGaussianBlur stdDeviation="2.5" />
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_9545_30615"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feMorphology
                radius="2"
                operator="erode"
                in="SourceAlpha"
                result="effect2_dropShadow_9545_30615"
              />
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="0.5" />
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0" />
              <feBlend
                mode="normal"
                in2="effect1_dropShadow_9545_30615"
                result="effect2_dropShadow_9545_30615"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="2" />
              <feGaussianBlur stdDeviation="1" />
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0" />
              <feBlend
                mode="normal"
                in2="effect2_dropShadow_9545_30615"
                result="effect3_dropShadow_9545_30615"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect3_dropShadow_9545_30615"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      </div>
    </div>
  );
};

export default MapPin;
